var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRainbow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9900"
    },
    d: "M418.202,385.581V258.136c0-89.211-72.991-162.202-162.202-162.202l0,0 c-89.211,0-162.202,72.991-162.202,162.202v127.444H418.202z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#60DD4D"
    },
    d: "M366.066,385.581v-96.858c0-67.8-49.53-123.274-110.066-123.274l0,0 c-60.536,0-110.066,55.473-110.066,123.274v96.858H366.066z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5B64B1"
    },
    d: "M296.551,385.581V276.156c0-0.828-0.014-1.654-0.038-2.477c-1.593-51.618-79.431-51.618-81.025,0 c-0.024,0.823-0.038,1.649-0.038,2.477v109.425H296.551z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF318F"
    },
    d: "M441.374,385.581h-34.758V263.929c0-40.045-15.717-77.818-44.258-106.358 S296.047,113.313,256,113.313s-77.818,15.717-106.358,44.258s-44.258,66.313-44.258,106.358v121.652H70.626V263.929 c0-49.329,19.333-95.83,54.438-130.935S206.671,78.556,256,78.556s95.83,19.333,130.935,54.438 c35.106,35.105,54.438,81.606,54.438,130.935L441.374,385.581L441.374,385.581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDB2D"
    },
    d: "M374.176,385.581h-34.758V263.929c0-45.997-37.421-83.418-83.418-83.418 s-83.418,37.421-83.418,83.418v121.652h-34.758V263.929c0-65.162,53.013-118.176,118.176-118.176s118.176,53.013,118.176,118.176 V385.581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4BBAED"
    },
    d: "M306.978,385.581H272.22V263.929c0-8.944-7.276-16.22-16.22-16.22c-8.944,0-16.22,7.276-16.22,16.22 v121.652h-34.758V263.929c0-28.11,22.868-50.978,50.978-50.978s50.978,22.868,50.978,50.978V385.581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B7E4F8"
    },
    d: "M216.264,343.455c0.002-0.197,0.003-0.394,0.003-0.591c0-27.361-22.26-49.62-49.62-49.62 c-1.36,0-2.716,0.056-4.064,0.166c-10.773-21.452-32.714-35.273-57.374-35.273c-35.426,0-64.248,28.821-64.248,64.248 c0,0.673,0.01,1.345,0.031,2.017C17.219,330.736,0,352.282,0,377.972c0,30.587,24.885,55.471,55.472,55.471h143.359 c25.747,0,46.694-20.947,46.694-46.694C245.525,367.448,233.532,350.451,216.264,343.455z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93D6F4"
    },
    d: "M216.264,343.455c0.002-0.197,0.003-0.394,0.003-0.591c0-27.361-22.26-49.62-49.62-49.62 c-1.36,0-2.716,0.056-4.064,0.166c-8.126-16.183-22.611-28.019-39.821-32.859v172.893h76.068c25.747,0,46.695-20.947,46.695-46.695 C245.525,367.448,233.532,350.451,216.264,343.455z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BF256B"
    },
    d: "M386.935,132.994C351.83,97.889,305.329,78.556,256,78.556v34.758 c40.045,0,77.818,15.717,106.358,44.258c28.541,28.541,44.258,66.313,44.258,106.358v121.652h34.758V263.929 C441.374,214.6,422.04,168.099,386.935,132.994z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4BBAED"
    },
    d: "M471.008,324.402c0.022-0.672,0.031-1.344,0.031-2.017c0-35.427-28.822-64.248-64.248-64.248 c-24.66,0-46.603,13.821-57.374,35.273c-1.349-0.11-2.704-0.166-4.064-0.166c-27.36,0-49.62,22.259-49.62,49.62 c0,0.197,0.001,0.394,0.003,0.591c-17.268,6.997-29.261,23.993-29.261,43.295c0,25.747,20.947,46.695,46.694,46.695h143.359 c30.587,0,55.472-24.884,55.472-55.471C512,352.282,494.781,330.736,471.008,324.402z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B8E4F7"
    },
    d: "M295.736,343.455c-0.002-0.197-0.003-0.394-0.003-0.591c0-27.361,22.26-49.62,49.62-49.62 c1.36,0,2.716,0.056,4.064,0.166c10.773-21.452,32.714-35.273,57.374-35.273c35.426,0,64.248,28.821,64.248,64.248 c0,0.673-0.01,1.345-0.031,2.017c23.773,6.335,40.992,27.88,40.992,53.572c0,30.587-24.885,55.471-55.472,55.471H313.169 c-25.747,0-46.694-20.947-46.694-46.695C266.475,367.448,278.468,350.451,295.736,343.455z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93D6F4"
    },
    d: "M471.008,324.402c0.022-0.672,0.031-1.344,0.031-2.017c0-35.427-28.822-64.248-64.248-64.248 c-6.058,0-11.948,0.839-17.554,2.414v172.893h67.291c30.587,0,55.472-24.884,55.472-55.471 C512,352.282,494.781,330.736,471.008,324.402z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainbow);
export default __webpack_public_path__ + "static/media/rainbow.90063f53f67f59f5d4c47041bbbfdc22.svg";
export { ForwardRef as ReactComponent };